/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, HFlow, Icon, Text, Tooltip, useTheme, VFlow } from 'bold-ui'

import { LembreteModel } from '../types/LembreteModel'

interface LembretesListCardProps {
  lembretes: LembreteModel[]
}

export function LembretesListCard(props: LembretesListCardProps) {
  const theme = useTheme()
  const classes = styles()
  return (
    <VFlow vSpacing={0.5}>
      {props.lembretes.map((lembrete, index) => {
        const { ultimoLembrete, isRegistradoAgora } = lembrete
        return (
          <HFlow hSpacing={0.5} alignItems='flex-start' key={index}>
            <Cell style={classes.text}>
              <li>
                <Text dangerouslySetInnerHTML={{ __html: ultimoLembrete.descricao.removeTags().truncate(50) }} />
              </li>
            </Cell>
            {isRegistradoAgora && (
              <Tooltip text='Registrado agora'>
                <Icon icon='clockOutline' color={theme.pallete.primary.c40} size={1} />
              </Tooltip>
            )}
          </HFlow>
        )
      })}
    </VFlow>
  )
}

const styles = () => ({
  text: css`
    word-break: break-word;
    padding: 0rem;
  `,
})
